import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/application/create',
			name: 'CreateApplication',
			component: () => import('./views/application/Create.vue'),
			meta: {
				title: 'Create Application',
				permission: 'tempvehicle.application.create'
			}
		},
		{
			path: '/setup-profile',
			name: 'SetupProfile',
			component: () => import('./views/profile/Setup.vue'),
			meta: {
				title: 'Setup Profile',
			}
		},

		/**
		 * Application
		 */
		{
			path: '/',
			name: 'Home',
			component: () => import('./views/Home.vue'),
			meta: {
				title: 'Home'
			}
		},
		{
			path: '/application/edit/:uuid',
			name: 'EditApplication',
			component: () => import('./views/application/Edit.vue'),
			meta: {
				title: 'Edit Application',
				// permission: 'tempvehicle.application.edit'
			}
		},
		{
			path: '/application',
			name: 'ApplicationList',
			component: () => import('./views/application/Index.vue'),
			meta: {
				title: 'Application List',
				// permission: 'tempvehicle.application.view'
			},
		},
		{
			path: '/application/search',
			name: 'SearchApplication',
			component: () => import('./views/application/Search.vue'),
			meta: {
				title: 'Search Application',
				permission: 'tempvehicle.application.view'
			},
		},
		{
			path: '/application/scan',
			name: 'ScanApplication',
			component: () => import('./views/application/Scan.vue'),
			meta: {
				title: 'Scan Application',
				permission: 'tempvehicle.application.view'
			},
		},
		{
			path: '/application/:uuid',
			name: 'ViewApplication',
			component: () => import('./views/application/View.vue'),
			meta: {
				title: 'View Application'
			},
		},

		/**
		 * Vehicle
		 */
		{
			path: '/vehicle',
			name: 'Vehicle',
			component: () => import('./views/vehicle/Index'),
			meta: {
				title: 'Vehicle',
				// permission: 'tempvehicle.vehicle.view'
			}
		},
		{
			path: '/vehicle/create',
			name: 'CreateVehicle',
			component: () => import('./views/vehicle/Create'),
			meta: {
				title: "Create Driver",
				// permission: 'tempvehicle.vehicle.create'
			}
		},
		{
			path: '/vehicle/edit/:id',
			name: 'EditVehicle',
			component: () => import('./views/vehicle/Edit'),
			meta: {
				title: "Edit Drivers",
				// permission: 'tempvehicle.vehicle.edit'
			}
		},
		{
			path: '/vehicle/:id',
			name: 'VehicleDetail',
			component: () => import('./views/vehicle/View'),
			meta: {
				title: 'Vehicle Detail',
				// permission: 'tempvehicle.vehicle.view'
			}
		},

		/**
		 * Driver
		 */
		{
			path: '/driver',
			name: 'Driver',
			component: () => import('./views/driver/Index'),
			meta: {
				title: "Drivers",
				// permission: 'tempvehicle.driver.view'
			}
		},
		{
			path: '/driver/create',
			name: 'CreateDriver',
			component: () => import('./views/driver/Create'),
			meta: {
				title: "Create Driver",
				// permission: 'tempvehicle.driver.create'
			}
		},
		{
			path: '/driver/edit/:id',
			name: 'EditDriver',
			component: () => import('./views/driver/Edit'),
			meta: {
				title: "Edit Drivers",
				// permission: 'tempvehicle.driver.edit'
			}
		},
		{
			path: '/driver/:id',
			name: 'ViewDriver',
			component: () => import('./views/driver/View'),
			meta: {
				title: "Drivers Detail",
				// permission: 'tempvehicle.driver.view'
			}
		},

		/**
		 *  Overstay
		 */
		{
			path: '/overstay',
			name: 'overstay',
			component: () => import('./views/overstay/overstay'),
			meta: {
				title: 'Overstay',
				permission: 'tempvehicle.overstay.view'
			}
		},
		
		/**
		 * Profile
		 */
		{
			path: '/profile',
			name: 'Profile',
			component: () => import('./views/profile/Profile'),
			meta: {
				title: 'Profile',
				// permission: 'tempvehicle.profile'
			}
		},

		/**
		 * Owner
		 */
		{
			path: '/owner',
			name: 'Owner',
			component: () => import('./views/owner/Index'),
			meta: {
				title: 'Owners',
				permission: 'tempvehicle.owner.view'
			}
		},
		{
			path: '/owner/create',
			name: 'CreateOwner',
			component: () => import('./views/owner/Create'),
			meta: {
				title: 'New Owner',
				permission: 'tempvehicle.owner.create'
			}
		},
		{
			path: '/owner/:id',
			name: 'ViewOwner',
			component: () => import('./views/owner/Details'),
			meta: {
				title: 'Owner Detail',
				permission: 'tempvehicle.owner.view'
			}
		},
		{
			path: '/owner/edit/:id',
			name: 'EditOwner',
			component: () => import('./views/owner/Update'),
			meta: {
				title: 'Edit Update',
				permission: 'tempvehicle.owner.edit'
			}
		},

		/**
		 * Settings
		 */
		{
			path: '/backend/vehicle-type',
			name: 'VehicleType',
			component: () => import('./views/backend/VehicleTypes'),
			meta: {
				title: 'Manage Vehicle Type',
				permission: 'tempvehicle.vehicle_type.view'
			}
		},
		{
			path: '/backend/fraud',
			name: 'Fraud',
			component: () => import('./views/backend/Frauds'),
			meta: {
				title: 'Manage Fraud',
				permission: 'tempvehicle.fraud.view'
			}
		},
		{
			path: '/backend/owner',
			name: 'SearchOwner',
			component: () =>import('./views/backend/Owners'),
			meta: {
				title: 'Manage Owner',
				permission: 'tempvehicle.owner.view'
			}
		},
		{
			path: '/backend/driver',
			name: 'SearchDriver',
			component: () =>import('./views/backend/Drivers'),
			meta: {
				title: 'Manage Driver',
				permission: 'tempvehicle.driver.view'
			}
		},
		{
			path: '/backend/vehicle',
			name: 'SearchVehicle',
			component: () =>import('./views/backend/Vehicles'),
			meta: {
				title: 'Manage Vehicle',
				permission: 'tempvehicle.vehicle.view'
			}
		},

        /**
         * Telegram
         */
        {
            path: '/telegram',
            name: 'Telegram',
            component: () => import('./views/telegram/Index'),
            meta: {
                title: 'Telegram',
            }
        },

		/**
		 * Authentications
		 */
		{
			path: '/backend/report',
			name: 'CreateReport',
			component: () => import('./views/backend/Report'),
			meta: {
				title: 'Create Report',
				// permission: 'tempvehicle.application.view'
			}
		},
		{
			path: '/login',
			name: 'login',
			component: () => import('./views/auth/Login'),
			meta: {
				title: 'Login',
				layout: 'blank'
			}
		},
		{
			path: '/register',
			name: 'register',
			component: () => import('./views/auth/Register'),
			meta: {
				title: 'Register',
				layout: 'blank'
			}
		},

		/**
		 * Errors! Remember! Never add routes after these routes!!!
		 */
		{
			path: '/abort/403',
			name: 'error_403',
			component: () => import('./views/errors/403.vue'),
			meta: {
				layout: 'blank',
				title: 'Unauthorized'
			}
		},
		{
			path: '*',
			name: 'error_404',
			component: () => import('./views/errors/404.vue'),
			meta: {
				layout: 'blank',
				title: 'Not found'
			}
		},
	]
})

// check for user permission
import store from "./store/index";
router.beforeResolve((to, from, next) => {
	if (to.meta.permission) {
		if (store.getters['user/getUserPermissions'] === null) {
			const watcher = store.watch(() => store.getters['user/getUserPermissions'], permissions => {
				watcher(); // stop watching
				let permissionsArray = permissions.map(a => a.name);
				if (!permissionsArray.includes(to.meta.permission)) {
					return next("/abort/403");
				}
			});

		} else {
			const permissions = store.getters['user/getUserPermissions'];
			let permissionsArray = permissions.map(a => a.name);
			if (!permissionsArray.includes(to.meta.permission)) {
				return next("/abort/403");
			}
		}
	}

	next();
});

router.beforeEach((to, from, next) => {
	// Document Title
	const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
	if (nearestWithTitle) document.title = nearestWithTitle.meta.title + " | " + process.env.VUE_APP_APP_NAME + " - " + process.env.VUE_APP_GDCE_SHORT;
	
	if (to.query.token) {
		const appPrefix = process.env.VUE_APP_PREFIX;
		localStorage.setItem(appPrefix + 'token', to.query.token);
		window.location.href = to.path;
	} else {
		// redirect to login page if not logged in and trying to access a restricted page
		const appPrefix = process.env.VUE_APP_PREFIX;
		const loggedIn = localStorage.getItem(appPrefix + "token");
		// console.log(loggedIn)

		// Check user authentication
		if (!loggedIn) {
			const redirectUrl = process.env.VUE_APP_USER_DASHBOARD_URL;
			//const port = window.location.port ? ':' + window.location.port : '';
			//const ref = window.location.protocol + '//' + window.location.hostname + port
			const ref = window.location.href;
			window.location.href = redirectUrl + '/login?ref=' + encodeURIComponent(ref);
		}
		next();
	}
});